import React from 'react';

export default function ChangeStatus(props) {
  // props.onBlueBtnPressed
  // props.onRedBtnPressed
  // props.onClose
  // props.titles
  return (
    <div className="flex flex-col bg-cust-medium-gray items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none p-1">
      {/* 첫 번째 파란색 버튼 (주문접수 등) */}
      {props.titles && props.titles[0] && (
        <button
          className={`justify-center items-center w-full h-24 font-bold text-white bg-primary ${
            props.titles[1] ? 'mb-1' : ''
          }`}
          onClick={() => {
            props.onBlueBtnPressed(props.item);
            props.onClose();
          }}
        >
          {props.titles[0]}
        </button>
      )}

      {/* 두 번째 빨간색 버튼 (접수거부/주문취소 등) - titles[1]이 존재할 때만 렌더링 */}
      {props.titles && props.titles[1] && (
        <button
          className="justify-center items-center w-full h-24 font-bold text-white bg-alert"
          onClick={() => {
            props.onRedBtnPressed(props.item);
            props.onClose();
          }}
        >
          {props.titles[1]}
        </button>
      )}
    </div>
  );
}